<mat-card>
    <mat-card-content class="newOrder">
        <!-- <button (click)="createLead()">Create Lead</button> -->
        <mat-card-title>
            <title-back [addTitle]="true" [Title]="'Lead list'" (back)="backToDashboard()"></title-back>

            <div class="tableFilter verifyCustTable">
                <logzy-reports-table [downloadButtons]="true" [pageName]="'verify_customer'"></logzy-reports-table>
                <!-- <mat-button-toggle-group [ngModel]="approvalStatus" (ngModelChange)="filterByApprovalStatus($event)"
                    name="fontStyle" aria-label="Font Style">
                    <mat-button-toggle value="pending">Pending</mat-button-toggle>
                    <mat-button-toggle value="approved">Approved</mat-button-toggle>
                    <mat-button-toggle value="rejected">Rejected</mat-button-toggle>
                </mat-button-toggle-group> -->
                <app-mat-auto-search [isEditable]="true" [(ngModel)]="verifyCustomerService.nature" fxLayout="column"
                    (change)="filterByNature($event)" [name]="'fontStyle'" [displayField]="'label'" fxFlex="12.4em"
                    [options]="filter_nature">
                </app-mat-auto-search>
                <app-mat-auto-search [isEditable]="true" [(ngModel)]="verifyCustomerService.approvalStatus"
                    fxLayout="column" (change)="filterByApprovalStatus($event)" [name]="'fontStyle'"
                    [displayField]="'label'" fxFlex="12.4em" [options]="status">
                </app-mat-auto-search>
                <mat-form-field appearance="outline" fxFlex="12.4em">
                    <input matInput [ngModel]="searchTerm" (ngModelChange)="applyFilter($event)" placeholder="Search">
                    <i class="flaticon-search" matSuffix></i>
                </mat-form-field>
                <button mat-raised-button class="Create Save sleekBtn" (click)="createLead()"><i
                        class="flaticon-box"></i> New Lead
                </button>
            </div>
        </mat-card-title>
        <logzy-table-loader *ngIf="loading"></logzy-table-loader>
        <div class="setTable" *ngIf="!loading">
            <ng-container *ngIf="userAndLeadList?.data.length">
                <mat-table [dataSource]="userAndLeadList" matSort (matSortChange)="announceSortChange($event)">

                    <ng-container [matColumnDef]="'transaction_type_display'">
                        <mat-header-cell *matHeaderCellDef> Nature</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 " (click)="view(data)">
                            <mat-chip *ngIf="data?.leads?.length>0"
                                class="natureChip">{{verifyModelService.getNatureOfRequest(data?.leads[0])}}
                            </mat-chip>
                            <mat-chip class="natureChip" *ngIf="data?.leads?.length==0">New Registration</mat-chip>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'lead_id'">
                        <mat-header-cell *matHeaderCellDef> Lead ID/Status</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 " (click)="view(data)">
                            <div class="vstack pointer">
                                {{data.leads.length != 0 ? data.leads[0]?.lead_number : '-'}}
                                <div *ngIf="data?.leads?.length>0">
                                    <mat-chip class="natureChip">{{ getLeadStatus(data.leads[0].lead_status) }}</mat-chip>
                                </div>
                            </div>
                            <ng-container *ngIf="data?.leads?.length==0">-</ng-container>
                        </mat-cell>
                    </ng-container>


                    <ng-container [matColumnDef]="'name'">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Lead Details</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12" (click)="view(data)">
                            <div class="vstack pointer">
                                <b> {{data.first_name}} {{data.last_name}} </b>
                                <span class="leadEmail">{{data.email}}</span>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'company'">
                        <mat-header-cell *matHeaderCellDef>Company</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <div class="vstack pointer">
                                <span class="companydetails" *ngIf="data.company!=null"><b> {{data.company?.name}} </b> <br> {{data.company?.primary_branch?.address}}</span>
                                <span class="companydetails" *ngIf="data.company==null"><b> {{data.company_name}} </b> <br> {{data.state?.name_display}}</span>

                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- <ng-container [matColumnDef]="'country'">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <img [src]="baseApiUrl + data?.state.country?.flag_url?.toLowerCase()"
                                    style="width: 18px; margin-right: 10px;" />
                            {{data.state?.country?.name}}
                        </mat-cell>
                    </ng-container> -->

                    <ng-container [matColumnDef]="'equipment'">
                        <mat-header-cell *matHeaderCellDef>Requirement</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <ng-container *ngIf="data.leads?.length > 0">
                                <span class="fs-12 " *ngIf="data.leads[0]?.requirements?.length">
                                    {{data.leads[0]?.requirements[0].quantity}}
                                    *{{data.leads[0]?.requirements[0].container_size_type?.display}}
                                    ({{data.leads[0]?.requirements[0].condition?.value}})
                                    <ng-container *ngIf="data.leads[0]?.requirements?.length > 1">
                                        <p [matTooltip]="data.leads[0]?.requirements | tooltipList"
                                            matTooltipClass="tooltip-list" matTooltipHideDelay="2000">
                                            + {{data.leads[0]?.requirements?.length - 1}} more
                                        </p>
                                    </ng-container>
                                </span>
                                <span class="fs-12 " *ngIf="data?.requirements?.length == 0">-</span>
                            </ng-container>
                            <ng-container *ngIf="data?.leads?.length==0">-</ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'created_at'">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            {{data?.created_at | date:"dd MMM, yyyy"}}
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'pol_list'">
                        <mat-header-cell *matHeaderCellDef>Pick-up</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="user_name">
                            <ng-container *ngIf="data.leads?.length > 0">
                                <span class="fs-12 " *ngIf="data.leads[0]?.pol_list?.length">
                                    {{data.leads[0]?.pol_list[0].name_display}}
                                    <ng-container *ngIf="data.leads[0]?.pol_list?.length > 1">
                                        <p [matTooltip]="data.leads[0]?.pol_list | tooltipList "
                                            matTooltipClass="tooltip-list" matTooltipHideDelay="2000">
                                            + {{data.leads[0]?.pol_list?.length - 1}} more
                                        </p>
                                    </ng-container>
                                </span>
                                <span class="fs-12 " *ngIf="data?.pol_list?.length == 0">-</span>
                            </ng-container>
                            <ng-container *ngIf="data?.leads?.length==0">-</ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container [matColumnDef]="'lead'">
                        <mat-header-cell *matHeaderCellDef>Lead Source</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <div *ngIf="data?.leads?.length>0">
                                <mat-chip class="natureChip">{{data.leads[0].request_source}}</mat-chip>
                            </div>
                            <ng-container *ngIf="data?.leads?.length==0">-</ng-container>
                        </mat-cell>
                    </ng-container>
                    <ng-container [matColumnDef]="'pod_list'">
                        <mat-header-cell *matHeaderCellDef>Drop-off</mat-header-cell>
                        <mat-cell *matCellDef="let data" class="fs-12 ">
                            <ng-container *ngIf="data.leads?.length > 0">
                                <span class="fs-12 " *ngIf="data.leads[0]?.pod_list?.length">
                                    {{data.leads[0]?.pod_list[0].name_display}}
                                    <ng-container *ngIf="data.leads[0]?.pod_list?.length > 1">
                                        <p [matTooltip]="data.leads[0]?.pod_list | tooltipList"
                                            matTooltipClass="tooltip-list" matTooltipHideDelay="2000">
                                            + {{data.leads[0]?.pod_list?.length - 1}} more
                                        </p>
                                    </ng-container>
                                </span>
                                <span class="fs-12 " *ngIf="data.leads[0]?.pod_list?.length == 0">-</span>
                            </ng-container>
                            <ng-container *ngIf="data?.leads?.length==0">-</ng-container>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row class="header-row" *matHeaderRowDef="displayColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayColumns;"
                        [class.blur]="updateUserAndLeadList"></mat-row>
                </mat-table>
                <div class="loadingData" [class.d-none]="!updateUserAndLeadList">
                    <logzy-gear-loader></logzy-gear-loader>

                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users" [pageSize]="10"
                    [length]="leadPageLength" (page)="pageChanged($event)"></mat-paginator>
            </ng-container>
            <ng-container *ngIf="!userAndLeadList?.data.length">
                <logzy-billu part1="No " part2="Data " part3="here." font="14px"></logzy-billu>
            </ng-container>
        </div>
    </mat-card-content>
</mat-card>
